import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const TooltipFormatter = ({ text, tooltip, placement }) => {
    const tooltipOverlay = (
        <Tooltip id="tooltip">{tooltip}</Tooltip>
    );

    const tooltipPlacement = _.isNil(placement) || _.isEmpty(placement) ? 'top' : placement;

    return (
        <div>
            <OverlayTrigger placement={tooltipPlacement} overlay={tooltipOverlay}><span>{text}</span></OverlayTrigger>
        </div>
    );
};

TooltipFormatter.propTypes = {
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    tooltip: PropTypes.string.isRequired,
    tooltipPlacement: PropTypes.string // Tooltip position: right, top, left, bottom
};

export default TooltipFormatter;
